import React, { useEffect, useState } from 'react';
import { Layout, Menu, Button } from 'antd';
import { HomeOutlined, TeamOutlined, ProjectOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Header, Content } = Layout;

export const PageLayout = ({ children, showManageInspectors = true }) => {
    const navigate = useNavigate();
    const [hasToken, setHasToken] = useState(false);

    // Check for fd_backend_token in localStorage when component mounts
    useEffect(() => {
        const token = localStorage.getItem('fd_backend_token');
        setHasToken(!!token);
    }, []);

    // Build menu items based on conditions
    const menuItems = [
        { key: '1', path: '/', label: 'Home', icon: <HomeOutlined /> },
        // Show Projects menu only if fd_backend_token exists
        ...(hasToken ? [{ key: '3', path: '/projects', label: 'Projects', icon: <ProjectOutlined /> }] : []),
        // Show Manage Inspectors based on prop
        ...(showManageInspectors
            ? [{ key: '2', path: '/field-service-inspectors', label: 'Manage Inspectors', icon: <TeamOutlined /> }]
            : [])
    ];

    return (
        <Layout className="inspectionWrapper">
            {/* Sticky Header */}
            <Header style={{ position: 'sticky', top: 0, zIndex: 1000, width: '100%', background: '#fff', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
                {/* Navigation Menu */}
                <Menu theme="light" mode="horizontal" className="container-xxl" style={{ marginBottom: '16px' }}>
                    {menuItems.map(item => (
                        <Menu.Item key={item.key} icon={item.icon}>
                            <Button type="link" onClick={() => navigate(item.path)}>
                                {item.label}
                            </Button>
                        </Menu.Item>
                    ))}
                </Menu>
            </Header>

            {/* Main Content */}
            <Content className="container-xxl" style={{ padding: '24px' }}>
                {children}
            </Content>
        </Layout>
    );
};

export default PageLayout;